export default __webpack_public_path__ + "static/media/check-list.93926b53.svg";